import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../AdminPanel.css";
import SuperAdminSidebar from "../SuperAdminSidebar";
import ManagerSidebar from "../ManagerSidebar";
import LeaderSidebar from "../LeaderSidebar";
import MemberSidebar from "../MemberSidebar";
import AdminNavbar from './AdminNavbar';
import { Link } from "react-router-dom";

const ViewVolet = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userName, setUserName] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [voletData, setVoletData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lname");

        if (!storedUserType) {
            navigate("/login");
        } else {
            setUserType(storedUserType);
            setUserName(storedUserName);
            if (storedFName && storedLName) {
                setUserFullName(`${storedFName} ${storedLName}`);
            } else if (storedFName) {
                setUserFullName(storedFName);
            } else {
                setUserFullName(storedUserName);
            }
        }
    }, [navigate]);

    useEffect(() => {
        fetchVoletData();
        fetchClients();
    }, []);

    useEffect(() => {
        if (selectedClient && voletData.length > 0) {
            const filtered = voletData.filter(item => {
                const itemClientId = Number(item.client_id);
                const selectedClientId = Number(selectedClient);
                return itemClientId === selectedClientId;
            });
            setFilteredData(filtered);
            console.log("Filtered data:", filtered);
        } else {
            setFilteredData([]);
        }
    }, [selectedClient, voletData]);

    const fetchVoletData = async () => {
        try {
            const response = await fetch("https://skcapi.btcjapan.co/fetchvolet.php");
            const data = await response.json();
            console.log("Fetched volet data:", data);
            
            const formattedData = data.map(item => ({
                ...item,
                client_id: Number(item.client_id),
                received_amount: parseFloat(item.received_amount) || 0,
                allocated_amount: parseFloat(item.allocated_amount) || 0,
                conversion_rate: parseFloat(item.conversion_rate) || 1
            }));
            setVoletData(formattedData);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching volet data:", error);
            setLoading(false);
        }
    };

    const fetchClients = async () => {
        try {
            const response = await fetch("https://skcapi.btcjapan.co/fetchclients.php");
            const data = await response.json();
            console.log("Fetched clients:", data);
            setClients(data);
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const formatCurrency = (amount) => {
        return `$${amount.toFixed(2)}`;
    };

    const formatPaymentMethod = (method) => {
        if (!method) return 'N/A';
        const methods = {
            'bank_transfer': 'Bank Transfer',
            'credit_card': 'Credit Card',
            'paypal': 'PayPal',
            'cash': 'Cash'
        };
        return methods[method] || method;
    };

    const formatConversionRate = (rate, currency) => {
        return `${rate.toFixed(4)} (${currency})`;
    };

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        localStorage.removeItem("usertype");
        localStorage.removeItem("fname");
        localStorage.removeItem("lname");
        navigate("/login");
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
              {userType === "administrator" && <SuperAdminSidebar />}
              {userType === "leader" && <LeaderSidebar />}
              {userType === "manager" && <ManagerSidebar />}
              {userType === "member" && <MemberSidebar />}
            </div>

            <div className="admin-content">
                {/* Use the new AdminNavbar component */}
                <AdminNavbar />

                <div className="main-section">
                    <h3 className='section-title'>View Volet</h3>

                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="clientFilter" className="form-label">Filter by Client</label>
                                    <select
                                        id="clientFilter"
                                        className="form-select"
                                        value={selectedClient}
                                        onChange={(e) => setSelectedClient(e.target.value)}
                                    >
                                        <option value="">Select a client</option>
                                        {clients.map(client => (
                                            <option key={client.id} value={client.id}>
                                                {client.name} ({client.username})
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {loading ? (
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-striped table-hover">
                                <thead className="table-dark">
                                    <tr>
                                        <th>ID</th>
                                        <th>Date</th>
                                        <th>Customer Name</th>
                                        <th>Payment Method</th>
                                        <th>Debit Amount</th>
                                        <th>Conversion Rate</th>
                                        <th>Allocation Amount</th>
                                        <th>Remaining Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        (() => {
                                            let remainingBalance = 0;
                                            return filteredData.map((item, index) => {
                                                if (index === 0) {
                                                    remainingBalance = item.received_amount - item.allocated_amount;
                                                } else {
                                                    remainingBalance = remainingBalance + item.received_amount - item.allocated_amount;
                                                }

                                                return (
                                                    <tr key={item.id}>
                                                        <td>{item.id}</td>
                                                        <td>{formatDate(item.date)}</td>
                                                        <td>{item.client_name}</td>
                                                        <td>{formatPaymentMethod(item.payment_method)}</td>
                                                        <td>{formatCurrency(item.received_amount)}</td>
                                                        <td>{formatConversionRate(item.conversion_rate, item.currency)}</td>
                                                        <td>{formatCurrency(item.allocated_amount)}</td>
                                                        <td className={remainingBalance < 0 ? 'text-danger' : ''}>
                                                            {formatCurrency(remainingBalance)}
                                                        </td>
                                                    </tr>
                                                );
                                            });
                                        })()
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                {selectedClient ? "No payment records found for selected client" : "Please select a client to view payments"}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ViewVolet;